// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeUploadStep-ListItem_cls1__URcbK","cls2":"PayeeUploadStep-ListItem_cls2__96ruU PayeeUploadStep-ListItem_cls1__URcbK"};